<div *ngIf="visible" id="toast" class="toast open">
    <div class="toast-body">{{ message }}</div>
    <div class="close-toast" (click)="close()">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="4" y1="4" x2="14" y2="14"/>
        <line x1="14" y1="4" x2="4" y2="14"/>
      </svg>
    </div>
  </div>